import React, { useState } from 'react';
import Logo from '../../_assets/images/logo@2x.png';
import PasswordChecklist from '../../_components/PasswordChecklist'

import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { userService } from '../../_services/user.service';
import { alertActions } from '../../_actions/alert.actions';
import { isValidPassword } from '../../_helpers/regex'

function ResetPassword({ dispatch, alert, history, match }) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordRequest, setPasswordRequest] = useState(false);

  return <div className="row h-100">
    <div className="col-lg-8 offset-lg-2 my-auto">
      <div className="card axs-shadow">
        <div className="row">
          <div className="col-lg-5 d-flex" style={{ backgroundColor: '#1AB2E9' }}>
            <img src={Logo} alt="AxS Logo" className="m-auto" />
          </div>

          <div className="col-lg-7">
            <h3 className="mt-3 text-center">Reset Password</h3>

            <form className="p-3">
              {alert.message &&
                <div className={`alert ${alert.type}`}>{alert.message}</div>
              }

              <div className="form-group">
                <label><span className="text-danger">*</span> Password</label>
                <input onChange={e => setPassword(e.target.value)} value={password} type="password" className="form-control" />
              </div>
              <div className="form-group">
                <label><span className="text-danger">*</span> Confirm Password</label>
                <input onChange={e => setConfirmPassword(e.target.value)} value={confirmPassword} type="password" className="form-control" />
              </div>

              <PasswordChecklist password={password} />

              <div className="form-group">
                <button onClick={() => {
                  if (password !== confirmPassword) {
                    dispatch(alertActions.error('Password does not match'));
                  } else if (!isValidPassword(password)) {
                    dispatch(alertActions.error('Password is invalid'));
                  } else {
                    setPasswordRequest(true);

                    userService.resetPassword(match.params.token, password)
                      .then(() => {
                        history.push('/login');

                        dispatch(alertActions.success('Password Updated!'));
                      })
                      .catch((error) => {
                        setPasswordRequest(false);

                        if (error && error.response) {
                          dispatch(alertActions.error(error.response.data.message));
                        } else {
                          dispatch(alertActions.error('Could not reset password at this time. Please try again.'));
                        }
                      })
                  }
                }}
                  disabled={passwordRequest || password === '' || confirmPassword === ''}
                  type="button"
                  className="btn btn-primary btn-block ">{passwordRequest ? 'Reset Password...' : 'Reset Password'}</button>
              </div>

              <Link to="/login" className="btn btn-link btn-block text-center">Login</Link>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
}

const mapStateToProps = state => {
  return {
    alert: state.alert
  };
}

export default connect(mapStateToProps)(ResetPassword);